import {PERSONAL_DATA_POLICY} from './personalDataPolicy';
import {PRIVACY_POLICY} from './privacyPolicy';
import {LegalDocument} from './types';
import {USER_AGREEMENT} from './userAgreement';

export type {LegalBlock, LegalDocument, LegalSection} from './types';
export {CONTACT_EMAIL, OPERATOR_NAME, OPERATOR_POSTAL_ADDRESS} from './types';

/**
 * Все правовые документы в порядке, в котором их читают: сначала правила
 * пользования, затем что происходит с данными, затем формальный документ по 152-ФЗ.
 * Тот же порядок — в футерах и в подписи чекбокса при регистрации.
 */
export const LEGAL_DOCUMENTS: LegalDocument[] = [USER_AGREEMENT, PRIVACY_POLICY, PERSONAL_DATA_POLICY];

/** Базовый путь публикации. Совпадает с `path` в реестре бэкенда. */
export const LEGAL_BASE_PATH = '/legal';

/** Полный путь страницы документа. */
export const legalPath = (document: LegalDocument): string => `${LEGAL_BASE_PATH}/${document.slug}`;

/** Документ по slug из адреса; `undefined` для неизвестного пути → страница 404. */
export const findLegalDocument = (slug: string | undefined): LegalDocument | undefined =>
    LEGAL_DOCUMENTS.find(document => document.slug === slug);

export {PERSONAL_DATA_POLICY, PRIVACY_POLICY, USER_AGREEMENT};
